import { render } from "./ProfitLoss.vue?vue&type=template&id=03db089e"
import script from "./ProfitLoss.vue?vue&type=script&lang=js"
export * from "./ProfitLoss.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__